import React from 'react';
import ModuleRoute from 'holocron-module-route';

const childRoutes = () => [
  <ModuleRoute path="/" key={0}>
    <ModuleRoute path="/track-my-card" moduleName="axp-servicing-card-tracking-non-logged-experience" key="axp-servicing-card-tracking-non-logged-experience" />
  </ModuleRoute>,
];

export default childRoutes;
